// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type MermaidQueryVariables = Types.Exact<{
  input: Types.MermaidInput;
}>;


export type MermaidQuery = { __typename?: 'Query', mermaid: { __typename?: 'MermaidResult', url: string, code: string } };

export type CatalogTaskIdsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CatalogTaskIdsQuery = { __typename?: 'Query', globalPlanTasks: { __typename?: 'GlobalPlanTasksPageResult', entities: Array<{ __typename?: 'GlobalPlanTask', id: string }> } };


export const MermaidDocument = gql`
    query Mermaid($input: MermaidInput!) {
  mermaid(input: $input) {
    url
    code
  }
}
    `;

/**
 * __useMermaidQuery__
 *
 * To run a query within a React component, call `useMermaidQuery` and pass it any options that fit your needs.
 * When your component renders, `useMermaidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMermaidQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMermaidQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MermaidQuery, MermaidQueryVariables> & ({ variables: MermaidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MermaidQuery, MermaidQueryVariables>(MermaidDocument, options);
      }
export function useMermaidLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MermaidQuery, MermaidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MermaidQuery, MermaidQueryVariables>(MermaidDocument, options);
        }
export function useMermaidSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MermaidQuery, MermaidQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MermaidQuery, MermaidQueryVariables>(MermaidDocument, options);
        }
export type MermaidQueryHookResult = ReturnType<typeof useMermaidQuery>;
export type MermaidLazyQueryHookResult = ReturnType<typeof useMermaidLazyQuery>;
export type MermaidSuspenseQueryHookResult = ReturnType<typeof useMermaidSuspenseQuery>;
export type MermaidQueryResult = Apollo.QueryResult<MermaidQuery, MermaidQueryVariables>;
export const CatalogTaskIdsDocument = gql`
    query CatalogTaskIds {
  globalPlanTasks(page: {limit: 1000}) {
    entities {
      id
    }
  }
}
    `;

/**
 * __useCatalogTaskIdsQuery__
 *
 * To run a query within a React component, call `useCatalogTaskIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCatalogTaskIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCatalogTaskIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCatalogTaskIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CatalogTaskIdsQuery, CatalogTaskIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CatalogTaskIdsQuery, CatalogTaskIdsQueryVariables>(CatalogTaskIdsDocument, options);
      }
export function useCatalogTaskIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CatalogTaskIdsQuery, CatalogTaskIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CatalogTaskIdsQuery, CatalogTaskIdsQueryVariables>(CatalogTaskIdsDocument, options);
        }
export function useCatalogTaskIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CatalogTaskIdsQuery, CatalogTaskIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CatalogTaskIdsQuery, CatalogTaskIdsQueryVariables>(CatalogTaskIdsDocument, options);
        }
export type CatalogTaskIdsQueryHookResult = ReturnType<typeof useCatalogTaskIdsQuery>;
export type CatalogTaskIdsLazyQueryHookResult = ReturnType<typeof useCatalogTaskIdsLazyQuery>;
export type CatalogTaskIdsSuspenseQueryHookResult = ReturnType<typeof useCatalogTaskIdsSuspenseQuery>;
export type CatalogTaskIdsQueryResult = Apollo.QueryResult<CatalogTaskIdsQuery, CatalogTaskIdsQueryVariables>;